import { Equal } from "@redotech/util/equal";
import * as contentType from "content-type";

/**
 * @file
 * @see {@link https://www.rfc-editor.org/rfc/rfc2045 RFC 2046 Multipurpose Internal Mail Extensions (MIME) Part One: Format of Internet Message Bodies}
 */

export class Type {
  constructor(readonly type: string) {}

  subtype(subtype: string) {
    return new MediaType(this.type, subtype);
  }

  static equals: Equal<Type> = (a, b) => a.type === b.type;
}

export class MediaType {
  // TODO: parameters
  constructor(
    readonly type: string,
    readonly subtype: string,
    readonly attributes: Map<string, string> = new Map(),
  ) {}

  clone() {
    return new MediaType(this.type, this.subtype, new Map(this.attributes));
  }

  toString() {
    return contentType.format({
      type: `${this.type}/${this.subtype}`,
      parameters: Object.fromEntries(this.attributes.entries()),
    });
  }

  static parse(value: string) {
    const parsed = contentType.parse(value);
    return new this(
      ...(<[string, string]>parsed.type.split("/")),
      new Map(Object.entries(parsed.parameters)),
    );
  }
}
